<template>
  <hic-dialog append-to-body title="代理配置编辑" :visible="visible" @close="cancel" width="50rem" @open="open" :close-on-click-modal="false">
    <el-form :model="value" :rules="comRules" ref="submitForm" label-width="5rem" label-position="right">
      <el-row>
        <el-col :span="8">
          <el-form-item label="源服务" prop="service">
            <el-input type="text" placeholder="请输入" v-model.trim="value.service" />
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="源路径" prop="path">
            <el-input type="text" placeholder="请输入" v-model.trim="value.path" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="目的服务" prop="redirectService">
            <el-input type="text" placeholder="请输入" v-model.trim="value.redirectService" />
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="目的路径" prop="redirectPath">
            <el-input type="text" placeholder="请输入" v-model.trim="value.redirectPath" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="方式" prop="redirectService">
            <el-select v-model.trim="value.method" placeholder="请选择">
              <el-option v-for="item in ['get', 'post', 'put', 'delete']" :key="item" :label="item" :value="item" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="停用" prop="redirectPath">
            <el-checkbox v-model.trim="value.disabled" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row slot="footer" type="flex" justify="end" align="middle">
      <el-button type="info" @click="cancel">关 闭</el-button>
      <el-button type="primary" @click="save">确 定</el-button>
    </el-row>
  </hic-dialog>
</template>

<script>
  import api from "./api";
  import { mapGetters } from "sw-hic";
  export default {
    props: {
      visible: Boolean,
      value: Object,
    },
    data() {
      return {
        meta: {
          loading: false,
        },
        comRules: {
          service: [{ required: true, message: "请选择源服务", trigger: "blur" }],
          path: [{ required: true, message: "请选择目的服务", trigger: "blur" }],
          redirectService: [{ required: true, message: "请输入源路径", trigger: "blur" }],
          redirectPath: [{ required: true, message: "请输入目的路径", trigger: "blur" }],
        },
        resultVal: "",
      };
    },
    computed: {
      ...mapGetters(["dict", "user", "dictEnum", "Enum"]),
    },
    methods: {
      open() {
        try {
          this.$set(this, "resultVal", "");
          this.$refs.submitForm.resetFields();
        } catch (error) {}
      },
      cancel() {
        this.$emit("update:visible", false);
        this.$emit("cancel");
      },
      save() {
        this.$refs.submitForm.validate().then((valid) => {
          if (valid) {
            this.meta.loading = true;
            api.PxySetting.save(this.value)
              .then((res) => {
                this.$message.success("保存成功!");
                this.$emit("close");
                this.cancel();
              })
              .catch((err) => {
                this.$message.error(err);
              })
              .finally(() => {
                this.meta.loading = false;
              });
          }
        });
      },
    },
  };
</script>
